import {Component, Inject, OnInit} from '@angular/core';
import {ButtonChangeLocationComponent} from "../../components/button-change-location/button-change-location.component";
import {AuthApiService} from "../../shared/core-jpats/services/auth.service";
import {UserManagementService} from "../../shared/core-jpats/services/user-management.service";
import {AccessService} from "../../system-management/shared/service/access.service";
import {RoleConstants} from "../../system-management/shared/core/role.constants";
import {BsModalRef,BsModalService} from "ngx-bootstrap/modal";
import {Router} from "@angular/router";
import {NdmsAuthService} from "../../../../../ndms/app/shared/core-ndms/services/ndms-auth.service";

@Component({
  selector: 'patients-home',
  templateUrl: './patients-home.component.html',
  styleUrls: ['./patients-home.component.scss']
})
export class PatientsHomeComponent implements OnInit {
  searchModel: boolean = false;

  currentFcc = null;
  currentLocation = null;
  currentOperation = null;
  get canEdit() {
    return !!(this.currentFcc?.active && this.currentLocation?.active && this.currentOperation?.active);
  }

  constructor(private authApiService: AuthApiService,
              private ndmsAuthApiService: NdmsAuthService,
              private userManagementService: UserManagementService,
              public roleConstants: RoleConstants,
              private modalService: BsModalService,
              private router: Router,
              @Inject('APP_PATH') public appPath: string,
              @Inject('SITE_MODE') public siteMode: string) {
    //The signal will never come in from ndmsAuthApiService, but I don't want to remove this block - just in case
    this.ndmsAuthApiService.resetPatientSearch.subscribe(() => {
      window.localStorage.removeItem("JpatsPatientSearch");
      this.searchModel = false;
    });
    this.authApiService.resetPatientSearch.subscribe(() => {
      window.localStorage.removeItem("JpatsPatientSearch");
      this.searchModel = false;
    });
    this.updateUserLocation();
    const locationChangedSub = this.userManagementService.locationChanged.subscribe((data) => {
      this.updateUserLocation();
    });
  }

  updateUserLocation() {
    this.userManagementService.getCurrentUser().subscribe((userData) => {
      if (userData.fcc) this.currentFcc = userData.fcc;
      if (userData.location) this.currentLocation = userData.location;
      if (userData.operation) this.currentOperation = userData.operation;
    });
  }

  async ngOnInit() {
    let showSearch: string = window.localStorage.getItem("JpatsPatientSearch");
    window.localStorage.removeItem("JpatsPatientSearch");
    if (showSearch) {
      this.searchModel = true;
    } else {
      this.searchModel = false;
    }

    if(this.authApiService.showPatientPopup)
      await this.showPopup();
  }

  async showPopup(){
    this.searchModel = false;
    let buttonChangeLocationComponent = new ButtonChangeLocationComponent(this.authApiService, this.modalService, this.router);
    this.authApiService.showPatientPopup = false;
    await buttonChangeLocationComponent.showModal(true);
  }

  ngOnDestroy() {

  }

  enableSearch(){
    this.searchModel = true;
  }

  disableSearch() {
    this.searchModel = false;
  }
}
